import debounce from 'lodash/debounce';

import { get } from 'helpers/api';

import type { OmniSearchResults, OmniSearchTab } from './types';

const OMNI_SEARCH_PATH = '/search/omni';
const DEFAULT_LIMIT = 5;

interface SearchOmniOptions {
  query: string;
  scope: OmniSearchTab;
  limit?: number;
}

export function searchOmni(
  { query, scope, limit = DEFAULT_LIMIT }: SearchOmniOptions,
  onSuccess: (results: OmniSearchResults) => void,
): void {
  get(OMNI_SEARCH_PATH, { params: { query, scope, limit } })
    .then((results: OmniSearchResults) => onSuccess(results || {}))
    .catch(() => onSuccess({}));
}

export const debouncedSearchOmni = debounce(
  (options: SearchOmniOptions, onSuccess: (results: OmniSearchResults) => void) => {
    searchOmni(options, onSuccess);
  },
  300,
);
